import { render, staticRenderFns } from "./IniciarAtendimento.vue?vue&type=template&id=25595626&scoped=true&"
import script from "./IniciarAtendimento.vue?vue&type=script&lang=js&"
export * from "./IniciarAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./IniciarAtendimento.vue?vue&type=style&index=0&id=25595626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25595626",
  null
  
)

export default component.exports